module.exports = __webpack_public_path__ + "hyperion-v2-static/img/baselayer-nova-btn-60x60.5eac22f6.png";